module.exports = __webpack_public_path__ + "img/right_arrow_gray.bc865654.svg";